import axios from '@axios'
import ApiRouteProvider, { objectToGETParams } from '../route'

const getBasePath = () => (
    `${ApiRouteProvider.getBaseUrl()}/research/document-research/processes`
)

export default {
    getStatuses(processIds) {
        const query = objectToGETParams({ ids: processIds })

        return axios.get(`${getBasePath()}/statuses${query ? `?${query}` : ''}`)
    },

    getProcess(processId) {
        return axios.get(`${getBasePath()}/${encodeURIComponent(processId)}`)
    },

    getCandidateContent(processId, candidateId) {
        return axios.get(
            `${getBasePath()}/${encodeURIComponent(processId)}`
            + `/candidates/${encodeURIComponent(candidateId)}/content`,
            { responseType: 'blob' },
        )
    },

    selectDocuments(processId, candidateIds) {
        return axios.post(
            `${getBasePath()}/${encodeURIComponent(processId)}/document-selection`,
            { candidateIds },
        )
    },

    finishWithoutDocuments(processId) {
        return axios.post(
            `${getBasePath()}/${encodeURIComponent(processId)}/finish-without-documents`,
            {},
        )
    },
}
